/** @format */

import OrdersEditPage from './OrdersEditPage';
export default OrdersEditPage;
